export enum IncomePeriod {
  PerMonth = "Per Month",
  PerYear = "Per Year"
}